import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { palette } from "../../theme/palette";
import { View } from "../View";

const useStyles = makeStyles(() => ({
  container: {
    padding: "0 0.4rem",
    height: "1.25rem",
    lineHeight: "1.25rem",
    fontSize: "0.75rem",
    textAlign: "center",
    borderRadius: "0.125rem",
    fontWeight: "bold",
    background: "green",
    color: "white",
    marginBottom: "9px",
    position: "relative",
  },
  shape: {
    position: "absolute",
    width: "0.25rem",
    height: "0.25rem",
    borderWidth: "0 0.094rem 0.094rem 0",
    borderColor: "white",
    borderStyle: "solid",
    bottom: "0.125rem",
    right: "0.125rem",
  },
}));

export const SectionLabel = ({ section }) => {
  const styles = useStyles();
  const { isActive } = section;

  return (
    <View
      style={{
        background: isActive ? section.colour : palette.translucentBlack,
        color: isActive
          ? section.textColour || palette.typography.white.high
          : palette.typography.white.high,
        display: "inline-block",
      }}
      className={styles.container}
    >
      {section.sectionName}
      <View className={styles.shape} />
    </View>
  );
};
